import Grid from '@mui/material/Grid';
export { Grid };
export default Grid;
//# sourceMappingURL=index.js.map